const stripTrailingSlash = (url?: string) => (url ?? "").replace(/\/+$/, "");

export const API_URL = stripTrailingSlash(import.meta.env.VITE_API_URL);
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
